// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2YUsK","footer":"ChangeClinic_footer__1C2gZ"};